import React, { useMemo } from 'react';
import ImageLoader from '@Components/ImageLoader/ImageLoader';
import { InfoCard, useSelectImages } from '@innovyze/stylovyze';
import { LiftStationFormFields } from '@Types';
import { useFormikContext } from 'formik';

export default function UpsertLiftStationImages() {
	const { values } = useFormikContext<LiftStationFormFields>();
	const { images: currentImageList } = values;
	const { images: fullImageList } = useSelectImages();

	const imagesData = useMemo(() => {
		if (!currentImageList) return [];
		return fullImageList.filter(image =>
			currentImageList.includes(image._id),
		);
	}, [currentImageList, fullImageList]);

	return (
		<>
			{imagesData.map(image => (
				<InfoCard
					key={image._id}
					fullHeight
					title={image.name}
					applyBodyPadding={false}>
					<ImageLoader imageKey={image.imageKey} />
				</InfoCard>
			))}
		</>
	);
}
